/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_GroupInputs */

const vi_media_owner_group = /** @type {(inputs: Media_Owner_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm sản phẩm`)
};

/**

* @param {Media_Owner_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_group = /** @type {((inputs?: Media_Owner_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_group(inputs)
});